module.exports = __webpack_public_path__ + "img/icon-search.f362bb6c.svg";